import Icon from '@components/v2/ui/Icon/Icon';
import Typography from '@components/v2/ui/Typography/Typography';
import Box from '@mui/material/Box';
import { Info } from 'lucide-react';
import LangEnum from '../../../../../../lang/LangEnum';
import { TranslateType } from '../../../../../../modules/translation/translationContext.types';
import Tooltip from '../../../../../Tooltip';

interface ColumnTitleWithTooltipProps {
  title: LangEnum | string;
  titleTooltip?: LangEnum;
  titleTooltipParam?: { [key: string]: string };
  tooltipIcon?: JSX.Element;
  translate: TranslateType;
  className?: string;
}

const ColumnTitleWithTooltip = ({
  title,
  className,
  tooltipIcon,
  titleTooltip,
  titleTooltipParam,
  translate,
}: ColumnTitleWithTooltipProps) => {
  const label = title ? translate(title as LangEnum) : '';

  return (
    <>
      <Typography variant="body1" color="text.secondary" className={className} title={label}>
        {label}
      </Typography>
      {titleTooltip && (
        <Tooltip title={translate(titleTooltip, titleTooltipParam)}>
          {tooltipIcon || (
            <Box component="span" sx={{ display: 'inline-flex' }}>
              <Icon icon={Info} size="lg" />
            </Box>
          )}
        </Tooltip>
      )}
    </>
  );
};

export default ColumnTitleWithTooltip;
